import Button, { ButtonProps } from '@mui/material/Button';
import React from 'react';

const TertiaryButton: React.FC<ButtonProps> = ({ children, ...rest }) => (
  <Button {...rest} variant="outlined" color="inherit">
    {children}
  </Button>
);

export default TertiaryButton;
